// This file is part of Moodle - http://moodle.org/
//
// Moodle is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// Moodle is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with Moodle.  If not, see <http://www.gnu.org/licenses/>.

/**
 * TODO describe module custombutton
 *
 * @module     local_edwiserpagebuilder/custombutton
 * @copyright  2025 YOUR NAME <your@email.com>
 * @license    http://www.gnu.org/copyleft/gpl.html GNU GPL v3 or later
 */


define(['jquery', 'core/modal_factory', 'core/modal_events', 'core/notification', 'core/ajax'],
    function($, ModalFactory, ModalEvents, Notification, Ajax) {

        function addAddblockBtn() {
            Ajax.call([{
                methodname: 'local_edwiserpagebuilder_do_page_action',
                args: {
                    action: 'add_addblock_floating_btn',
                    config: addblockmodalcontext
                },
                done: function(response) {
                    response = JSON.parse(response);

                    $('body').append(response.html);

                    // Initialize floating handler after button is added
                    require(['local_edwiserpagebuilder/floating_add_block_handler', 'local_edwiserpagebuilder/custompages'], function(handler, custompages) {
                        handler.init();
                        custompages.init();
                    });
                },
                fail: function(ex) {
                    Notification.exception(ex);
                }
            }]);
        }


    return {
        init: function() {
            addAddblockBtn();
        }
    };
});
